
import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Building } from 'lucide-react';

export function HubSelector() {
  const [hub, setHub] = React.useState('hub-1');

  const hubs = [
    { value: 'hub-1', label: 'Bưu cục Quận 1' },
    { value: 'hub-2', label: 'Bưu cục Quận 2' },
    { value: 'hub-3', label: 'Bưu cục Quận 3' },
    { value: 'store-1', label: 'Cửa hàng Nguyễn Văn Cừ' },
    { value: 'store-2', label: 'Cửa hàng Lê Văn Việt' },
  ];

  return (
    <Select value={hub} onValueChange={setHub}>
      <SelectTrigger className="w-48 bg-white/10 border-white/20 text-white hover:bg-white/20">
        <Building className="h-4 w-4 mr-2" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {hubs.map((hub) => (
          <SelectItem key={hub.value} value={hub.value}>
            {hub.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
